import { render, staticRenderFns } from "./ProductEquipment.vue?vue&type=template&id=8a1b76c8&scoped=true&"
import script from "./ProductEquipment.vue?vue&type=script&lang=js&"
export * from "./ProductEquipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1b76c8",
  null
  
)

export default component.exports